import { render } from "./LoginDashboard.vue?vue&type=template&id=03b84edc&scoped=true"
import script from "./LoginDashboard.vue?vue&type=script&lang=js"
export * from "./LoginDashboard.vue?vue&type=script&lang=js"

import "./LoginDashboard.vue?vue&type=style&index=0&id=03b84edc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b84edc"]])

export default __exports__